;(() => {
  /**
   * kb-accessibility.js
   * Navigazione: TAB per livelli orizzontali, FRECCE per livelli verticali.
   * Include: Protezione totale contro theme.js.
   */

  
  const ST = {
    mode: "top",
    activeDropdown: null
  };

  // ── 1. SCUDO CONTRO IL TEMA (MONKEY PATCH) ────────────────────────────────
  const originalFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(options) {
    const stack = new Error().stack || "";
    const activeEl = document.activeElement;
    
    const isUserOnRadio = activeEl && (activeEl.tagName === 'INPUT' && activeEl.type === 'radio');
    const isUserInMenu  = activeEl && activeEl.closest('.header__menu');
    
    // Se il tema prova a rubare il focus mentre l'utente è nel menu o sulle taglie
    if ((stack.includes('theme.js') || stack.includes('vendor.js')) && (isUserOnRadio || isUserInMenu)) {
      return; 
    }
    return originalFocus.apply(this, arguments);
  };

  // ── 2. LOGICA DI NAVIGAZIONE IBRIDA ───────────────────────────────────────
  const ROOT_SEL     = '.header__menu';
  const TOPLINK_SEL  = '.navlink--toplevel';
  const DROPDOWN_SEL = '.header__dropdown';
  const CHILD_SEL    = '.navlink--child';
  const GRAND_SEL    = '.navlink--grandchild';

  // Sblocca/Blocca tabindex per permettere il TAB solo dove serve
  function updateTabIndices(root) {
    // Di default tutto ciò che è nel dropdown è fuori dal TAB nativo
    root.querySelectorAll(`${DROPDOWN_SEL} a`).forEach(a => a.setAttribute('tabindex', '-1'));

    if (ST.mode === 'submenu' && ST.activeDropdown) {
      // Quando siamo nel sottomenu, solo i "navlink--child" (le testate delle colonne) sono tabbarili
      ST.activeDropdown.querySelectorAll(CHILD_SEL).forEach(a => a.removeAttribute('tabindex'));
    }
  }

  function init() {
    const root = document.querySelector(ROOT_SEL);
    if (!root) return false;

    updateTabIndices(root);

    root.addEventListener('keydown', (e) => {
      const target = e.target;
      const isTopLink = target.matches(TOPLINK_SEL);
      const isChild   = target.matches(CHILD_SEL);
      const isGrand   = target.matches(GRAND_SEL);

      // --- CASO A: Sei su un link principale (UOMO, ecc.) ---
      if (isTopLink) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const item = target.closest('li');
          const dd = item.querySelector(DROPDOWN_SEL);
          if (dd) {
            ST.mode = 'submenu';
            ST.activeDropdown = dd;
            item.setAttribute('aria-expanded', 'true');
            updateTabIndices(root);
            // Focus sul primo child (es. ABBIGLIAMENTO)
            const firstChild = dd.querySelector(CHILD_SEL);
            if (firstChild) firstChild.focus();
          }
        }
        if (e.key === 'Tab') {
          ST.mode = 'top'; // Il tab naturale si sposta al prossimo top link
        }
      }

      // --- CASO B: Sei su una testata colonna (ABBIGLIAMENTO, COLLEZIONI) ---
      else if (isChild) {
        // Se premi FRECCIA GIU, vai nella lista della colonna
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const firstGrand = target.nextElementSibling?.querySelector(GRAND_SEL);
          if (firstGrand) firstGrand.focus();
        }
        // Se premi TAB, vai alla prossima colonna (comportamento nativo sbloccato)
        if (e.key === 'Escape') {
          const parentTop = target.closest('.menu__item').querySelector(TOPLINK_SEL);
          ST.mode = 'top';
          updateTabIndices(root);
          parentTop.focus();
        }
      }

      // --- CASO C: Sei dentro le sottovoci (Capispalla, Maglieria) ---
      else if (isGrand) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          const colList = target.closest('ul');
          const links = [...colList.querySelectorAll(GRAND_SEL)];
          const idx = links.indexOf(target);
          const nextIdx = e.key === 'ArrowDown' ? idx + 1 : idx - 1;
          
          if (links[nextIdx]) {
            links[nextIdx].focus();
          } else if (e.key === 'ArrowUp' && idx === 0) {
            // Torna alla testata della colonna (Child)
            target.closest('li.dropdown__family')?.querySelector(CHILD_SEL)?.focus();
          }
        }
        // Se premi TAB usciamo dal menu per sicurezza o torniamo al top
        if (e.key === 'Tab' || e.key === 'Escape') {
           // Chiudi e torna su
        }
      }
    }, true);

    // Reset se il focus esce dal menu
    document.addEventListener('focusin', (e) => {
      if (!root.contains(e.target)) {
        ST.mode = 'top';
        ST.activeDropdown = null;
        root.querySelectorAll('.menu__item[aria-expanded="true"]').forEach(el => el.setAttribute('aria-expanded', 'false'));
        updateTabIndices(root);
      }
    }, true);

    return true;
  }

  // Blocco frecce per radio button (Taglie)
  window.addEventListener('keydown', (e) => {
    if (e.key.includes('Arrow') && e.target.type === 'radio') {
      e.stopImmediatePropagation();
    }
  }, true);

  if (!init()) {
    const iv = setInterval(() => { if (init()) clearInterval(iv); }, 500);
  }
})();